
import { motion } from 'framer-motion';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import ContactMap from './components/ContactMap';
import CertificatesSection from './components/CertificatesSection';

export default function ContactPage() {
  return (
    <>
      <Navigation />
      <ContactHero />

      {/* Form + Info Section */}
      <section id="formularz" className="relative py-14 sm:py-24 bg-[#111111]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-5 gap-8 lg:gap-12">
            {/* Left — Info */}
            <div className="lg:col-span-2 order-2 lg:order-1">
              <ContactInfo />
            </div>

            {/* Right — Form */}
            <div className="lg:col-span-3 order-1 lg:order-2">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="bg-[#0A0A0A] border border-[#00E5FF]/10 p-5 sm:p-8 md:p-10"
              >
                <div className="mb-5 sm:mb-8">
                  <span
                    className="text-[#00E5FF] text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] uppercase font-semibold"
                    style={{ fontFamily: 'Orbitron, sans-serif' }}
                  >
                    Formularz kontaktowy
                  </span>
                  <h2
                    className="text-xl sm:text-2xl font-bold text-white mt-2 sm:mt-3 leading-tight"
                    style={{ fontFamily: 'Rajdhani, sans-serif' }}
                  >
                    Napisz do <span className="text-[#00E5FF]">Nas</span>
                  </h2>
                  <div className="h-[2px] w-12 sm:w-16 bg-[#00E5FF] mt-3 sm:mt-4"></div>
                </div>
                <ContactForm />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <ContactMap />
      <CertificatesSection />

      {/* CTA Section */}
      <section className="relative py-16 sm:py-28 bg-[#111111]">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/c20529ecc4293316821042f334bd7ac5.jpg"
            alt="Współpraca przemysłowa"
            className="w-full h-full object-cover object-center opacity-10"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#111111] via-[#111111]/90 to-[#111111]"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <h2
              className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              Gotowy na <span className="text-[#00E5FF]">Projekt?</span>
            </h2>
            <p
              className="text-sm sm:text-lg text-[#C0C7CF] mb-8 sm:mb-10 max-w-2xl mx-auto px-2"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Zadzwoń lub napisz — odpowiemy w ciągu 24 godzin z indywidualną wyceną dla Twojego
              projektu.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-2">
              <a
                href="tel:+48600978050"
                className="w-full sm:w-auto px-8 sm:px-10 py-3.5 sm:py-4 bg-[#00E5FF] text-[#050505] font-bold text-xs sm:text-sm hover:bg-white transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 sm:gap-3 active:scale-[0.98]"
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                <i className="ri-phone-line text-base sm:text-lg"></i>
                +48 600 978 050
              </a>
              <a
                href="#formularz"
                className="w-full sm:w-auto px-8 sm:px-10 py-3.5 sm:py-4 border border-[#00E5FF] text-[#00E5FF] font-bold text-xs sm:text-sm hover:bg-[#00E5FF] hover:text-[#050505] transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 sm:gap-3 active:scale-[0.98]"
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                <i className="ri-mail-line text-base sm:text-lg"></i>
                Wyślij zapytanie
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </>
  );
}
